export default "__VITE_ASSET__BtnOpyut__"